module.exports = __webpack_public_path__ + "img/scene5-8.89f59e4b.jpg";